<template>
  <div>
    <MovieList :movies="dorms" v-if="dorms"/>
    <FixedPopup :dorms="popupDorms" v-if="popupDorms && popupDorms.length > 0"/>
  </div>
</template>

<script>
import MovieList from '@/components/MovieList'
import FixedPopup from '@/components/FixedPopup'
import axios from 'axios'
import { mapGetters } from 'vuex'
import { SET_TOTAL_RESULTS } from '@/store/mutations.type'
export default {
  name: 'StudioProduct',
  components: {
    MovieList,
    FixedPopup
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.pageTitle,
      meta: [
        { vmid: 'description', name: 'description', content: this.pageDescription },
        { vmid: 'keywords', name: 'keywords', content: this.pageKeywords }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: this.url }
      ]       
    }
  },
  data () {
    return {
      page: 1,
      studio: '',
      url: '',
      dorms: null,
      errors: [],
      gender: '',
      typeID: null,
      popupDorms: null,
      details: null
    }
  },
  methods: {
    checkGender () {
      if (this.$route.params.type === 'tvshows') {
        this.gender = 'TV Shows'
        this.typeID = 'tv'
      } else if (this.$route.params.type === 'movies') {
        this.gender = 'Movies'
        this.typeID = 'movie'
      }
    },
    getDorms () {
      this.checkGender()
      let self = this
      self.dorms = null
      this.studioId = window.localStorage.getItem('studioId')
      axios//.get(`/site/universities/dorms/${self.$route.params.slug}?dorm_type=${self.typeID}`)
        .get(`/3/discover/${self.typeID}?api_key=a11ac97c6bdb99adc0845654be0902a8&with_companies=${this.studioId}&page=${this.page}`)
        .then(response => {
          self.dorms = response.data.results
          self.$store.commit(SET_TOTAL_RESULTS, response.data.total_results)
          // self.popupDorms = response.data.popups
        })
        .catch(e => {
          this.errors.push(e)
        })
    }
  },
  computed: {
    ...mapGetters(['universityDetails']),
    pageTitle () {
      let title = ''
      if (this.universityDetails) {
        if (this.typeID === 1) title = this.universityDetails.male_title
        else if (this.typeID === 2) title = this.universityDetails.female_title
      }
      return title
    },
    pageDescription () {
      let title = ''
      if (this.universityDetails) {
        if (this.typeID === 1) title = this.universityDetails.male_description
        else if (this.typeID === 2) title = this.universityDetails.female_description
      }
      return title
    },
    pageKeywords () {
      let title = ''
      if (this.universityDetails) {
        if (this.typeID === 1) title = this.universityDetails.male_keywords
        else if (this.typeID === 2) title = this.universityDetails.female_keywords
      }
      return title
    }
  },
  created () {
    this.getDorms()
    this.url = window.location.origin + this.$route.fullPath //  '/' + this.$route.params.slug + '-movies/'
  },
  watch: {
    $route () {
      this.checkGender()
      this.getDorms()
    }
  }
}
</script>

<style scoped>

</style>
